import React from "react";
import PropTypes from "prop-types";
import { FormGroup, Label } from "reactstrap";

// This component exists to wrap an input element (and optionally any validation elements)
// to abstract away layout decisions into a single component

function InputGroup(props) {
  const { children, isValid, labelText, name } = props;
  const containerClassName =
    isValid === false ? "col-sm-10 has-danger" : "col-sm-10";

  return (
    <FormGroup row>
      <Label htmlFor={name} sm={2}>
        {labelText}
      </Label>
      <div className={containerClassName}>{children}</div>
    </FormGroup>
  );
}

InputGroup.propTypes = {
  labelText: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isValid: PropTypes.bool
};

export default InputGroup;



// WEBPACK FOOTER //
// ./src/Shared/Forms/InputGroup.js